import { BasicProps } from "../../../common/components/ComponentsInterface";

export const AdminAsideNavIconContainer = ({ ...props }: BasicProps): JSX.Element => {
    return <span className="icon pl-5 pr-5">{props.children}</span>;
};
